import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'selector', 'Selector', [["path",{"d":"M8 9l4 -4l4 4","key":"svg-0"}],["path",{"d":"M16 15l-4 4l-4 -4","key":"svg-1"}]]);